import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

const InterestRateCard = ({ card, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                    <div className="text-4xl">{card.icon}</div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(card)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(card.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-3">
                    <h3 className="text-lg font-bold text-slate-800">
                        {card.title}
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed">
                        {card.description}
                    </p>
                    <div className="flex items-center justify-between pt-2">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${card.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {card.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">Order #{card.display_order}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InterestRateCard;
